"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
export interface SyncStep {
  id: string;
  label: string;
  status: "pending" | "in_progress" | "completed" | "error";
  error?: string;
}

/**
 * Hook to manage sync status
 * Returns methods to update step statuses
 */
export function useSyncStatus(initialSteps) {
  const $ = _c(6);
  const [steps, setSteps] = useState(initialSteps);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (stepId, status, error) => {
      setSteps(prev => prev.map(step => step.id === stepId ? {
        ...step,
        status,
        error
      } : step));
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const updateStep = t0;
  let t1;
  if ($[1] !== initialSteps) {
    t1 = () => {
      setSteps(initialSteps.map(_temp));
    };
    $[1] = initialSteps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resetSteps = t1;
  let t2;
  if ($[3] !== resetSteps || $[4] !== steps) {
    t2 = {
      steps,
      updateStep,
      resetSteps,
      setSteps
    };
    $[3] = resetSteps;
    $[4] = steps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(step_0) {
  return {
    ...step_0,
    status: "pending" as const
  };
}